export default __webpack_public_path__ + "static/media/cholet4.6a5615d0.jpg";